import React from "react";
import { Box } from "@mui/material";
import { DoctorManagement } from "../../DoctorManagement/DoctorManagement";

/**
 * Doctors / Clinics tab of the Registry page.
 *
 * The existing DoctorManagement view (search + clinic-with-doctors table) is
 * reused as-is. No new components are introduced for this tab.
 */
const RegistryDoctorsTab: React.FC = () => {
  return (
    // Full-height flex column so the clinic table inside can be its own
    // scroll container with a sticky header (same pattern as the other tabs).
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <DoctorManagement />
    </Box>
  );
};

export default RegistryDoctorsTab;
